import { et3CheckText } from ".";

export const checkIfHasBadWordsAndSocialMedia = (message: string) => {
  const {
    isEmailExist,
    isSocialMediaExits,
    isBadWordsExists,
    isPhoneNumberExists,
    isRestrictedPhrasesExists
  } = et3CheckText(message);
  const hasSocialMedia =
    isEmailExist || isSocialMediaExits || isPhoneNumberExists;
  const hasBadWords = isBadWordsExists || isRestrictedPhrasesExists;
  return {
    hasSocialMedia: hasSocialMedia,
    hasBadWords: hasBadWords
  };
};
